import React from "react";
import { Alert, AlertTitle, Box, Link, Typography } from "@mui/material";
import { PauseCircleOutlined } from "@mui/icons-material";

import useAuth from "../../hooks/useAuth";
import { SUPPORT_EMAIL } from "../../utils/support";

/**
 * Shown in place of the whole dashboard when the active association's
 * subscription has been frozen. Deliberately shows nothing about the
 * association's data — only who to contact.
 */
const AssociationSuspended: React.FC = () => {
  const { currentUser } = useAuth();
  const associationName = currentUser?.activeAssociation?.name;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        py: 10,
      }}
    >
      <PauseCircleOutlined
        sx={{ fontSize: 64, color: "warning.main", mb: 3 }}
      />

      <Typography variant="h3" gutterBottom>
        Tilaus on jäädytetty
      </Typography>

      <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 520 }}>
        {associationName
          ? `Tiekunnan ${associationName} tilaus on tällä hetkellä jäädytetty, eikä palvelua voi käyttää.`
          : "Tiekuntasi tilaus on tällä hetkellä jäädytetty, eikä palvelua voi käyttää."}
      </Typography>

      <Alert severity="info" sx={{ mt: 5, maxWidth: 520, textAlign: "left" }}>
        <AlertTitle>Miten jatkan?</AlertTitle>
        Ota yhteyttä ylläpitoon osoitteessa{" "}
        <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>, niin
        selvitetään tilanne ja avataan tilaus uudelleen.
      </Alert>

      <Typography variant="body2" color="textSecondary" sx={{ mt: 4 }}>
        Tietosi ovat tallessa. Jos kuulut useampaan tiekuntaan, voit vaihtaa
        toiseen yläpalkista.
      </Typography>
    </Box>
  );
};

export default AssociationSuspended;
